import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, Image } from 'react-native';
import { PieChart } from "react-native-svg-charts";
import { Defs, LinearGradient, Stop } from 'react-native-svg';

import HeaderDefault from "../../components/HeaderDefault";
import Button from '../../components/Button';

import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from "./styles";

const MyBalance = ({ navigation, route }) => {
    const data = [
        {
            value: 70,
            svg: { fill: 'url(#grad1)' },
        },
        {
            value: 30,
            svg: { fill: 'rgba(35, 35, 35, 0.6)' },
        },
    ];

    const Gradient1 = () => (
        <Defs key={'grad1'}>
            <LinearGradient id={'grad1'} x1={'0%'} y={'0%'} x2={'0%'} y2={'90%'}>
                <Stop offset={'-54.97%'} stopColor={'#1F26BF'} />
                <Stop offset={'120.97%'} stopColor={'#32BFB1'} />
            </LinearGradient>
        </Defs>
    );


    const [uri, setUri] = useState('');
    const [qtd, setQtd] = useState(1);
    const [nameToken, setNameToken] = useState('GPX TOKEN');
    const [valueToken, setValueToken] = useState(1);
    const [saldo, setSaldo] = useState(0);
    const [validade, setValidade] = useState(false);


    useEffect(() => {
        getDataCoin();
        getBalanceCoin();

        route.params.qtd ? setQtd(route.params.qtd) : setQtd(1)
    }, []);

    const getDataCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        api.get(`/actives/${idCoin}`, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                // console.log(res.data)
                setNameToken(res.data.actives[0].name_token)
                setUri(`https://filesgpx.s3.us-east-2.amazonaws.com/${res.data.actives[0].path}`)

                res.data.actives[0].type_value == "Valor Fixo" ?
                    setValueToken(res.data.actives[0].single_value)
                    : setValueToken(res.data.actives[0].total_value_token)

            })
            .catch((error) => {
                console.log(error);
            })
    }

    const getBalanceCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.get('balanceGpxcoin', { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                //console.log(res.data)
                if (res.data.balance[0]?.available_balance) {
                    setSaldo(res.data.balance[0].available_balance);
                } else {
                    setSaldo(res.data.balance[0].saldo);
                }

            })
            .catch((error) => {
                console.log("erro1", error);
            })
    }

    useEffect(() => {
        if (saldo > (valueToken * qtd) && saldo != 0)
            setValidade(true);
    }, [saldo, qtd, valueToken]);



    return (
        <>
            <HeaderDefault title={'Meu saldo'} />

            <View style={styles.container}>
                <Text style={styles.titlePage}>Saldo disponível:</Text>

                <View style={styles.contentCard}>

                    <View style={styles.contentGraphic}>
                        <PieChart style={{ height: 140 }}
                            data={data}
                            endAngle="70"
                            startAngle={0}
                            padAngle={0}
                            innerRadius={'78%'}
                            outerRadius={'95%'}
                        >
                            <Gradient1 />
                        </PieChart>
                        <View style={styles.contentAmountCoins}>
                            <Text style={styles.valueCoin}>GPX: {saldo}</Text>
                            <View style={styles.hrGraphic} />
                            <Text style={styles.valueCoin}>BRL: {saldo}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.hr} />

                <View style={styles.contentPurchase}>
                    <Text style={styles.textInfoPurchase}>Valor da compra:</Text>
                    <Text style={styles.coinPurchase}>{qtd * valueToken} BRL</Text>
                </View>

                <View style={styles.contentImgCoin}>
                    <Image source={{ uri: uri }} style={styles.imgCoin} />
                </View>

                <Text style={styles.nameCoin}>{nameToken}</Text>
                <Text style={styles.priceCoin}>{valueToken}BRL</Text>

                <Text style={styles.amountCoin}>
                    Quantidade: <Text style={styles.amountCoinBold}>{qtd}</Text>
                </Text>
            </View>
            {validade ?
                <Button route={"ConfirmPassword"} text={"CONTINUAR"} props={{ qtd: qtd, valueToken: valueToken }} titlePage={"Confirmar compra"} />
                :
                <Button route={"PaymentMethod"} text={"SALDO INSUFICIENTE"} />
            }

        </>
    );
}

export default MyBalance;